import API from './API';
var PrizeDistributionService = {
    getPrizeDistribution: function (id, config) {
        return API.get("/prize_distributions/".concat(id), config);
    },
    getPrizeDistributions: function (config) {
        return API.get('/prize_distributions', config);
    }
};
export default PrizeDistributionService;
